import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    destinatarios: [],
    destinatariosMostrador: [],
    totalPaginas: 5,
  },
  mutations: {

    getDestinatarios(state, datos) {
      state.destinatarios = datos;
    },
    getDestinatarioMostrador(state, datos) {
      state.destinatariosMostrador = datos;
    },
    getPag(state, datos) {
      state.totalPaginas = datos;
    },

    destroyDestinatarios(state) {
      state.destinatarios = [];
    },

    destroyDestinatariosMostrador(state, datos) {
      state.destinatariosMostrador = [];
    },

  },
  actions: {
    async getDestinatarios({
      commit,
    }, dest) {
      try {
        const res = await api.getDestinatarios(dest);
        if (res.data.DATOS) {
          commit('getPag', res.data.INFO.paginacion.Paginas);
          commit('getDestinatarios', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async getDestinatarioMostrador({
      commit,
    }, dest) {
      try {
        const res = await api.getDestinatarioMostrador(dest);
        if (res.data.INFO.cod === '200') {
          commit('getDestinatarioMostrador', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async insertDestinatarios({ }, dest) {
      try {
        const res = await api.insertDestinatarios(dest);
        if (res.data.INFO.cod === '200') {
          return [true, res.data.destinatario.ID];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        return [false, 'errorcarga']
      }
    },

    async destroyDestinatarios({ commit }) {
      commit('destroyDestinatarios');
    },
    async destroyDestinatariosMostrador({ commit }) {
      commit('destroyDestinatariosMostrador');
    },

    async deleteDestinatarios({ }, dest) {
      try {
        const res = await api.deleteDestinatarios(dest);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

    async editDestinatarios({ }, dest) {
      try {
        const res = await api.editDestinatarios(dest);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO];
      } catch (error) {
        return [false, 'errorcarga']
      }
    },

  },
};
